/* eslint import/extensions: 0 */
import { Modal, Tooltip } from 'bootstrap/dist/js/bootstrap.esm.js';

document
  .querySelectorAll('[data-toggle="tooltip"], [data-bs-toggle="tooltip"]')
  .forEach((el) => new Tooltip(el));

// document
//   .querySelectorAll('[data-toggle="dropdown"], [data-bs-toggle="dropdown"]')
//   .forEach((el) => new Dropdown(el));

// document
//   .querySelectorAll('[data-bs-toggle="popover"]')
//   .forEach((el) => new Popover(el));

document
  .querySelectorAll('[data-bs-toggle="modal"]')
  .forEach((el) => new Modal(el));
